import { Link } from "react-router-dom";

interface LogoProps {
  variant?: "dark" | "light"; // dark = for light backgrounds; light = for navy
  withTagline?: boolean;
  className?: string;
}

/** The Maayad wordmark: logo image + serif name + tagline. */
export default function Logo({
  variant = "dark",
  withTagline = true,
  className = "",
}: LogoProps) {
  const nameColor = variant === "light" ? "text-white" : "text-navy-900";
  const taglineColor = variant === "light" ? "text-white/70" : "text-navy-700/70";

  return (
    <Link to="/" className={`flex items-center gap-2.5 ${className}`}>
     <img
          src="/logo .png"
          alt="Maayad "
          className="h-9 w-9 object-contain shrink-0"
        />
      <div className="leading-none">
        <span className={`block font-display text-2xl font-bold ${nameColor}`}>
          Maayad
        </span>
        {withTagline && (
          <span
            className={`mt-0.5 block text-[10px] font-medium tracking-wide ${taglineColor}`}
          >
            Beyond Travel. Into Stories.
          </span>
        )}
      </div>
    </Link>
  );
}